// Single source of truth for supported file types
export const SUPPORTED_FILE_TYPES = {
  extensions: ['.csv', '.vbo', '.log', '.gpc'],
  mimeTypes: {
    'text/csv': ['.csv'],
    'application/octet-stream': ['.vbo', '.log', '.gpc'],
    'text/plain': ['.log']
  }
};

// File size limits
export const MAX_FILE_SIZE_MB = 20;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

// Helper function to validate file extensions
export const validateFileType = (file: File): boolean => {
  const fileName = file.name.toLowerCase();
  return SUPPORTED_FILE_TYPES.extensions.some(ext => fileName.endsWith(ext));
};

// Helper function to validate file size
export const validateFileSize = (file: File): boolean => {
  return file.size <= MAX_FILE_SIZE_BYTES;
};

// Helper function to format file size for display
export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

// Helper function to get accept string for file inputs
export const getFileAcceptString = (): string => {
  return SUPPORTED_FILE_TYPES.extensions.join(',');
};
